import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IOAuthClient } from './useGetOAuthClients';

export interface ICreateOAuthClientRequest {
	name: string;
	description?: string;
	redirectUris: string[];
	scopes?: string[];
}

export function usePostOAuthClientMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (client: IOAuthClient) => void;
	onError?: (err: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (request: ICreateOAuthClientRequest) =>
			userSession.webServiceHelper.callAsync<IOAuthClient>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'oauthclients',
				}),
				'POST',
				request
			),
		onError,
		onSuccess,
	});
}
